export enum FirmUserApiEndpoint {
  Me = 'me',
  GetAllClientIndividuals = 'client-individuals',
  GetClientIndividual = 'client-individuals/{personCode}',
  GetClientPortfolios = 'clients/{personCode}/portfolios',
  GetClientPortfolio = 'clients/{personCode}/portfolios/{portfolioCode}',
  GetPortfolioAssets = 'clients/{personCode}/portfolios/{portfolioCode}/assets',
  GetPortfolioValuation = 'clients/{personCode}/portfolios/{portfolioCode}/valuation',
  GetPortfolioPerformance = 'clients/{personCode}/portfolios/{portfolioCode}/performance',
  GetAllClientEntities = 'client-entities',
  GetClientEntity = 'client-entities/{personCode}',
}
